import {Component, OnInit/*, Input*/, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FlashMessagesService} from "angular2-flash-messages";

import {InscricaoService} from './inscricao.service';
import {Inscricao} from './inscricao';
import {AcessoService} from "../acesso/acesso.service";
import {AppComponent} from "../app.component";
import {AcessoComponent} from "../acesso/acesso.component";


declare var jQuery:any;


@Component({
    selector: 'app-inscricao',
    templateUrl: './inscricao.component.html',
    styleUrls: ['./inscricao.component.css'],
    providers: [
        InscricaoService,
        AcessoService
    ]
})
export class InscricaoComponent extends AppComponent implements OnInit, OnDestroy {

    // @Input() evento_id:number;

    inscricao: Inscricao;

    sub: any;

    aplicacao: AppComponent;


    trabalho: number;
    relator: number;
    coautor: number;
	edit: boolean;
	carregado: boolean;

    msgRetorno: string = "";

    onSubmit() {
		this.setUser();
		this.spinnerService.show();
		if (!this.inscricao.id)
			this.inscricaoService.save(this.inscricao, '').then(response => this.redirect(response.json().dados));
		else 
			this.inscricaoService.save(this.inscricao, '/update').then(response => this.goBack());
    }
	
	// Upload dos documentos
	atribuir_identidade(event: any): void {
		this.inscricao.identidade = event.target.files[0];
	}
	atribuir_cpf(event: any): void {
		this.inscricao.cpf = event.target.files[0];
	}
	atribuir_crid(event: any): void {
		this.inscricao.crid = event.target.files[0];
	}

    redirect(dados) {
		if (dados.perfil_autoria_id == 3 && this.trabalho == 2) {
			this.router.navigateByUrl("trabalho" + "/" + dados['id']);
		} else {
			this.router.navigateByUrl("inscricao-list");
		}
    }

    setEvent() {
        this.sub = this.route.params.subscribe(params => {
                this.inscricao.evento_id = +params['id']; // (+) converts string 'id' to a number
            }
        );
    }


    setUser() {
        this.inscricao.usuario_id = +this.acessoService.getUsuario().id;
    }

    ngOnInit() {
        if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else {
			this.inscricao = new Inscricao;
			this.inscricao.perfil_autoria_id = 0;
			this.coautor = 0;
			this.setEvent();
			this.inscricao.perfil_autoria_id=1;
			this.carregado = this.edit = true;
		}
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/inscricao/inscricao.component.ts